import React, { useContext } from 'react';
import './BookingSearch.css';
import { useParams } from 'react-router';
import PageLoader from '../PageLoader';
import { LanguageContext } from '../../context/LanguageContext';


const BookingSearch = () => {
  window.scroll(0,0);
  const {Language} = useContext(LanguageContext); 
  const [isMounted, setIsMounted] = React.useState(false);
  const {currency, checkin, checkout} = useParams();
  
  const langParam = Language?.value || "es";
  const url = `https://direct-book.com/properties/hostelnut?locale=${langParam}currency=${currency}&checkInDate=${checkin}&checkOutDate=${checkout}`;
  
  //<div class="ibe" data-region="emea" data-channelcode="hostelnut" data-widget="embbed"></div>
  
  React.useEffect(()=>{
    setIsMounted(true);
  },[]);
  return (
    
    <>
      <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
        <div className="layout-container flex h-full grow flex-col">
          <main className="flex flex-col items-center w-full">
            
        
        <PageLoader/>
          {isMounted && (
            <iframe class='engine-frame' src={url}></iframe>
          ) }
          </main>
        </div>
        
      </div>
  </>
    
  );
};

export default BookingSearch;